import { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

type EventName = 'request' | 'response' | 'sign-out' | 'org-expired';

interface TimeParams {
  starttime?: number;
  endtime?: number;
}

interface RequestCallbackParam {
  config: AxiosRequestConfig & TimeParams;
  error?: AxiosError;
}

interface ResponseCallbackParam {
  data?: CustomSuccessData<any>;
  error?: CustomErrorData;
  config: AxiosRequestConfig & TimeParams;
}

interface CallbackParamType {
  request: RequestCallbackParam;
  response: ResponseCallbackParam;
  'sign-out': null;
  'org-expired': null;
}

type CallbackType = Record<EventName, (param?: CallbackParamType[EventName], ...args: any[]) => void>;

type EventMap = Record<EventName, CallbackType[EventName][]>;

export default class {
  private eventMap: EventMap = {
    request: [],
    response: [],
    'sign-out': [],
    'org-expired': [],
  };

  public on(eventName: 'request', eventCb: (param: RequestCallbackParam, ...args: any[]) => void): void;

  public on(eventName: 'response', eventCb: (param: ResponseCallbackParam, ...args: any[]) => void): void;

  public on(eventName: 'sign-out', eventCb: () => void): void;

  public on(eventName: 'org-expired', eventCb: () => void): void;

  public on<T extends EventName>(eventName: T, eventCb: CallbackType[T]): void {
    this.eventMap[eventName].push(eventCb);
  }

  off<T extends EventName>(eventName: T, eventCb: CallbackType[T] | '*'): void {
    const eventList = this.eventMap[eventName];
    if (eventCb === '*') {
      for (let i = eventList.length - 1; i >= 0; i -= 1) {
        eventList.splice(i, 1);
      }
    } else {
      for (let i = eventList.length - 1; i >= 0; i -= 1) {
        if (eventCb === eventList[i]) {
          eventList.splice(i, 1);
        }
      }
    }
  }

  public emit<T extends EventName>(eventName: T, param?: CallbackParamType[T], ...args: any[]): void {
    this.eventMap[eventName].forEach(eventCb => {
      const ans = eventCb(param, ...args);
    });
  }
}
